import { Spinner, Stack } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import ProofLocationCard from '../../../../components/ProofLocationCard/ProofLocationCard';
import { useLocation } from 'react-router-dom';
import { useGetProofLocationSpecialResultCompetition } from '../../../../services/hooks/ProofLocation/useGetProofLocationSpecialResultCompetition';
import AllocationInfoMobilePage from '../Mobile/AllocationInfo';
import { useContext } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';

const ProofLocationSpecialResultCompetition: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);
  const registrationId = useLocation().pathname.split('/')[3];
  const stepId = useLocation().pathname.split('/')[6];
  const proofLocationData = useGetProofLocationSpecialResultCompetition({
    registrationId: registrationId,
    stepId: stepId,
  });
  const widhtLabel = ['', '', '', '', ''];
  const boxDisplay = ['', '', 'flex', 'flex', 'flex'];
  const boxGap = ['', '', '5px', '5px', '5px'];

  if (isMobile) return <AllocationInfoMobilePage title="Convocação de etapa" data={proofLocationData?.data} />;

  return (
    <MainCard title="ÁREA DO CANDIDATO " subtitle="- CONVOCAÇÃO DE ETAPA">
      {proofLocationData?.isLoading ? (
        <Stack align="center" justify="center">
          <Spinner />
        </Stack>
      ) : (
        <ProofLocationCard
          boxDisplay={boxDisplay}
          boxGap={boxGap}
          proofLocationData={proofLocationData?.data}
          widhtLabel={widhtLabel}
          showDownloadButton={true}
        />
      )}
    </MainCard>
  );
};

export default ProofLocationSpecialResultCompetition;
